/**
 * A one-time sign-in link to hand to someone: copy it, or send it straight to
 * Telegram. Whoever opens it signs in with their own Telegram, which is then
 * attached to the account the link was made for.
 */
import { Check, Copy, Send } from 'lucide-react';
import { useState } from 'react';
import { Button } from './button';
import { toast } from './feedback';

export function AccessLinkPanel({
  url,
  expiresAt,
  who,
}: {
  url: string;
  expiresAt: string;
  who?: string;
}) {
  const [copied, setCopied] = useState(false);
  const text = who
    ? `${who}, вход в Gertsak — откройте ссылку и войдите через Telegram:`
    : 'Вход в Gertsak — откройте ссылку и войдите через Telegram:';
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Не удалось скопировать', {
        description: 'Выделите ссылку и скопируйте вручную',
      });
    }
  };
  return (
    <div className="space-y-3 rounded-xl border border-primary-line bg-primary-soft p-4">
      <p className="text-md font-semibold">Ссылка для входа</p>
      <p className="select-all break-all rounded-lg bg-surface px-3 py-2 font-mono text-sm">
        {url}
      </p>
      <div className="grid grid-cols-2 gap-2">
        <Button size="lg" onClick={() => void copy()}>
          {copied ? (
            <Check className="size-5" aria-hidden />
          ) : (
            <Copy className="size-5" aria-hidden />
          )}
          {copied ? 'Скопировано' : 'Копировать'}
        </Button>
        <Button
          size="lg"
          variant="primary"
          onClick={() =>
            window.open(
              `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
              '_blank',
              'noopener',
            )
          }
        >
          <Send className="size-5" aria-hidden />В Telegram
        </Button>
      </div>
      <p className="text-sm text-ink-3">
        Работает один раз, до {new Date(expiresAt).toLocaleDateString('ru-RU')}. Отправьте её только
        этому человеку.
      </p>
    </div>
  );
}
